import { faCircleQuestion as fasCircleQuestion } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfoPopup } from "bm-ui-kit";
import compact from "lodash/compact";
import React from "react";
import type { ReactNode } from "react";

export interface DataBoxProps {
	className?: string;
	contentClassName?: string;
	title?: ReactNode;
	value?: ReactNode;
	info?: ReactNode;
	orderBy?: boolean;
	highlightOrderedValue?: boolean;
}

export class DataBox extends React.Component<DataBoxProps> {
	public render(): ReactNode {
		const { className = "col-md-4 col-12", orderBy, info } = this.props;

		if (info) {
			return (
				<InfoPopup
					className={compact([
						`result-data-box result-data-info-icon`,
						className,
						orderBy && "ordered-by",
					]).join(" ")}
					tooltip={info}
				>
					{this.renderContent()}
					<FontAwesomeIcon icon={fasCircleQuestion} />
				</InfoPopup>
			);
		}

		return (
			<div className={compact([`result-data-box`, className, orderBy && "ordered-by"]).join(" ")}>
				{this.renderContent()}
			</div>
		);
	}

	private renderContent(): ReactNode {
		const {
			title,
			value,
			contentClassName = "py-lg-3 py-md-2 py-1 justify-content-between",
			orderBy = false,
			highlightOrderedValue = false,
		} = this.props;

		return (
			<div
				className={`result-data-content text-sm-center flex-sm-column justify-content-sm-center align-items-center flex-row-reverse d-flex h-100 ${contentClassName}`}
			>
				<strong
					className={["result-data-value", orderBy && highlightOrderedValue && "font-weight-black"].join(" ")}
				>
					{value}
				</strong>
				{title && <div className="result-data-title">{title}</div>}
			</div>
		);
	}
}
